let idCounter = 0;

export const uniqueId = (prefix = '') => {
  idCounter += 1;
  return `${prefix}${idCounter}`;
};
